import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { Box, Button, IconButton, Popover, MenuItem } from "@mui/material";
import { HttpService } from "../../service/HttpService";
import { useAuth } from "../../context/AuthProvider";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import { FaFileExcel, FaFilter } from "react-icons/fa";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";
import dayjs from "dayjs";
import { Decryption } from "../../Mixin/EncryptDecryptId";
import { useNavigate, useParams } from "react-router-dom";
import { TbFilterEdit } from "react-icons/tb";
import "./SopsListAdd/Sops.scss";
import Excel from "../../assets/img/excel.png";
import Word from "../../assets/img/word.png";
import Pdf from "../../assets/img/pdf.png";
import Video from "../../assets/img/video.png";
import { BsArrowLeft } from "react-icons/bs";
import DeleteModal from "../../components/Model/DeleteModal";
import Checkbox from "@mui/material/Checkbox";
import { GoTrash } from "react-icons/go";
import { getFileName } from "../../utils/common";
import { Encryption } from "../../Mixin/EncryptDecryptId";
import { HiOutlineEye } from "react-icons/hi2";
import SopFileHistoryModal from "./SopFileHistoryModal";

const radioOptions = [
  { value: "today", label: "Today" },
  { value: "week", label: "This Week" },
  { value: "month", label: "This Month" },
  { value: "specific", label: "Specific Date Range" },
];

const SopHistory = () => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);
  const [sopDetails, setSopDetails] = useState([]);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [label, setLabel] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params || {};
  const decryptedId = id && Decryption(id);
  const historyDateFilter = localStorage.getItem("sopHistoryDateFilter");
  const dateFilterData = historyDateFilter
    ? JSON.parse(historyDateFilter)
    : null;
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );
  const [selectedId, setSelectedId] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [fileId, setFileId] = useState();

  const handleRadioChange = () => {
    const setlabel =
      radioOptions.find((option) => option.value === selectedRadio)?.label ||
      "";
    setLabel(setlabel);
  };

  const fetchSopHistory = async () => {
    setLoading(true);
    try {
      const response = await httpService.get(
        `sops/get_sopHistoryById/${decryptedId}?start_date=${startDate}&end_date=${endDate}`
      );
      setHistory(
        response?.data?.history?.map((item, idx) => ({
          id: item.history_id,
          no: idx + 1,
          date: item.date,
          sop_file: item.file,
          filename: item.filename,
          task_names: item.task_names, // Add this line
        })) || []
      );
      setSopDetails(response?.data?.sopdetails);
    } catch (error) {
      setHistory([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleRadioChange();
    fetchSopHistory();
  }, []);

  const handleOpenDateModal = () => setOpenDateModal(true);
  const handleCloseDateModal = () => setOpenDateModal(false);
  const handleFetchWithFilter = () => {
    fetchSopHistory();
    const dateFilter = {
      startDate: startDate,
      endDate: endDate,
      selectedRadio: selectedRadio,
    };
    localStorage.setItem("sopHistoryDateFilter", JSON.stringify(dateFilter));
    handleRadioChange();
    setOpenDateModal(false);
  };

  // Checkbox logic
  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = history.map((row) => row.id);
      setSelectedId(allIds);
    } else {
      setSelectedId([]);
    }
    setIsAllSelected(isChecked);
  };
  const isIdSelected = (id) => selectedId.includes(id);
  const toggleId = (id) => {
    setSelectedId((prev) => {
      if (prev.includes(id)) {
        const updated = prev.filter((item) => item !== id);
        setIsAllSelected(false);
        return updated;
      } else {
        const updated = [...prev, id];
        if (updated.length === history.length) setIsAllSelected(true);
        return updated;
      }
    });
  };

  // Delete logic
  const handleDelete = (id) => {
    setDeleteRowId(id);
    setBulkDelete(false);
    setOpenDeleteModal(true);
  };
  const handleBulkDelete = () => {
    setBulkDelete(true);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteRowId(null);
    setBulkDelete(false);
  };
  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      if (bulkDelete) {
        await httpService.post("sops/delete_all_sopHistory", {
          ids: selectedId,
        });
        setSelectedId([]);
        setIsAllSelected(false);
        fetchSopHistory();
      } else if (deleteRowId) {
        await httpService.delete(`sops/sopHistoryDelete/${deleteRowId}`);
        setSelectedId([]);
        fetchSopHistory();
      }
    } catch (e) {
      // handle error if needed
    }
    setLoading(false);
    handleCloseDeleteModal();
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setDataId(id);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setDataId(null);
  };

  const handleOpenHistory = () => {
    setOpenHistory(true);
    // fetchUsedQuantity();
  };

  const handleClose = () => {
    setOpenHistory(false);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <>
          <div className="action_icon-weap">
            <IconButton onClick={(e) => handleMenuClick(e, params.row.id)}>
              <GridMoreVertIcon />
            </IconButton>
          </div>
          {anchorEl && dataId === params.row.id && (
            <Popover
              className="popup-menu"
              key={dataId}
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  handleDelete(params.row.id);
                  handleCloseMenu();
                }}
                className="menu-list-items"
              >
                <div className="menu-list-items-text">Delete</div>
                <GoTrash style={{ cursor: "pointer" }} />
              </MenuItem>
            </Popover>
          )}
        </>
      ),
    },
    {
      field: "select_All",
      headerName: "",
      minWidth: 50,
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Checkbox
          checked={isAllSelected ? true : isIdSelected(params.row.id)}
          onChange={() => toggleId(params.row.id)}
        />
      ),
      renderHeader: () => (
        <Checkbox
          checked={isAllSelected}
          onChange={handleHeaderCheckboxChange}
        />
      ),
    },
    {
      field: "sop_file",
      headerName: "SOP File",
      flex: 1,
      minWidth: 200,
      // align: "center",
      headerAlign: "center",
      cellClassName: "wrap-text",
      renderCell: (params) => {
        const { sop_file, date, filename } = params.row;
        let fileIcon = null;
        let fileName = sop_file ? sop_file.split("/").pop() : "";
        let fileBase = fileName;
        let fileExt = "";
        if (fileName) {
          const lastDot = fileName.lastIndexOf(".");
          if (lastDot !== -1) {
            fileBase = fileName.substring(0, lastDot);
            fileExt = fileName.substring(lastDot);
          }
        }
        if (sop_file) {
          const lower = sop_file.toLowerCase();
          if (lower.endsWith(".pdf")) {
            fileIcon = Pdf;
          } else if (lower.endsWith(".doc") || lower.endsWith(".docx")) {
            fileIcon = Word;
          } else if (lower.endsWith(".xls") || lower.endsWith(".xlsx")) {
            fileIcon = Excel;
          } else if (
            lower.endsWith(".mp4") ||
            lower.endsWith(".mov") ||
            lower.endsWith(".avi") ||
            lower.endsWith(".mkv") ||
            lower.endsWith(".webm") ||
            lower.endsWith(".flv") ||
            lower.endsWith(".wmv") ||
            lower.endsWith(".3gp")
          ) {
            fileIcon = Video; // Replace with your actual video icon component/import
          }
        }
        let fileHref = sop_file;
        if (fileIcon === Word || fileIcon === Excel) {
          fileHref = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
            sop_file
          )}`;
        }
        // Format date as DD-MM-YYYY h:mm
        let dateStr = date ? dayjs(date).format("DD-MM-YYYY h:mm") : "";
        // Compose display name
        let displayName = getFileName(fileName);
        if (dateStr) displayName += `_${dateStr}`;
        if (fileExt) displayName += fileExt;
        return (
          <div
            className="profile-img-wrap"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            {sop_file && (
              <a
                href={fileHref}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "inline-block" }}
              >
                <div className="d-flex align-items-center">
                  {fileIcon ? (
                    <img
                      src={fileIcon}
                      alt="file-type"
                      className="profile-img"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    <img src={sop_file} alt="profile" className="profile-img" />
                  )}
                  <span
                    title={filename?.replace(/\.[^/.]+$/, "")}
                    style={{ marginRight: 8, fontWeight: 500 }}
                  >
                    {filename?.replace(/\.[^/.]+$/, "")}
                  </span>
                </div>
              </a>
            )}
          </div>
        );
      },
    },
    {
      field: "task_names",
      headerName: "Tasks",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      cellClassName: "wrap-text",
      renderCell: (params) => {
        const value = params.value;
        if (Array.isArray(value)) {
          return value.join(", ");
        }
        return value || "--";
      },
    },
    {
      field: "history",
      headerName: "Employee History",
      flex: 0.5,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { id, filename } = params.row;
        return (
          <div
            onClick={() => {
              setFileId({ id: id, name: filename });
              handleOpenHistory();
            }}
            title="View File History"
          >
            {/* <HiOutlineEye style={{ fontSize: 22 }} /> */}
            <span
              style={{
                cursor: "pointer",
                color: "#0000FF",
                textDecorationLine: "underline",
              }}
            >
              Show
            </span>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return params.value
          ? dayjs(params.value).format("MM-DD-YYYY hh:mm A")
          : "--";
      },
    },
  ];

  return (
    <div className="sops">
      {loading && <FullScreenLoader />}
      <div className="page-title">
        <div className="title-wrap">
          <h1>
            <span className="back">
              <BsArrowLeft onClick={() => navigate("/sops")} />
            </span>
            History Of SOP - {sopDetails?.name ? `(${sopDetails?.name})` : ""}
          </h1>
        </div>
        <div>
          {/* <Button
            variant="contained"
            color="primary"
            startIcon={<FaFileExcel />}
            className="me-3"
          >
            Download
          </Button> */}
          <Button
            variant="outlined"
            color="primary"
            onClick={handleOpenDateModal}
            className="filters-btn"
          >
            <TbFilterEdit /> Filter
          </Button>
        </div>
      </div>
      {/* Bulk Delete Button */}
      <div style={{ margin: "16px 0" }}>
        <Button
          variant="contained"
          color="error"
          disabled={selectedId.length === 0}
          onClick={handleBulkDelete}
          startIcon={<GoTrash />}
          style={{ textTransform: "none", fontWeight: 600 }}
        >
          Delete
        </Button>
      </div>
      <Box mt={3}>
        <DataGrid
          rows={history}
          columns={columns}
          getRowHeight={() => "auto"}
          pageSizeOptions={[10, 25, 50]}
          disableRowSelectionOnClick
          sx={{
            background: "#fff",
            borderRadius: 2,
            [`& .MuiDataGrid-cell`]: { py: 1 },
          }}
          hideFooter
        />
      </Box>
      <DateTimeModal
        handleDateTimeModal={handleCloseDateModal}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        open={openDateModal}
        fetchSchedule={handleFetchWithFilter}
        selectedRadio={selectedRadio}
        setSelectedRadio={setSelectedRadio}
        startDate={startDate}
        endDate={endDate}
      />
      {/* Delete Modal */}
      <DeleteModal
        open={openDeleteModal}
        HandleClose={handleCloseDeleteModal}
        HandleDelete={handleConfirmDelete}
      />
      {openHistory && (
        <SopFileHistoryModal
          open={openHistory}
          handleClose={() => handleClose()}
          data={fileId}
        />
      )}
    </div>
  );
};

export default SopHistory;
